/**
 * @generated SignedSource<<1cfc4fde1e4fbd7f5764a96ae2c27fbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignInputScreenQuery$variables = {
  campaignId: string;
};
export type CampaignInputScreenQuery$data = {
  readonly campaign: {
    readonly __typename: "Campaign";
    readonly " $fragmentSpreads": FragmentRefs<"CampaignInputCampaign">;
  } | {
    readonly __typename: "NotFoundError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly influencer: {
    readonly " $fragmentSpreads": FragmentRefs<"CampaignInputInfluencer">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputAddressPrefecture" | "CampaignInputCategoryMCategories">;
};
export type CampaignInputScreenQuery = {
  response: CampaignInputScreenQuery$data;
  variables: CampaignInputScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "campaignId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "campaignId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "NotFoundError",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "campaign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CampaignInputCampaign"
              }
            ],
            "type": "Campaign",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Influencer",
        "kind": "LinkedField",
        "name": "influencer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CampaignInputInfluencer"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CampaignInputCategoryMCategories"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CampaignInputAddressPrefecture"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "campaign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentMediaType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasDelivery",
                "storageKey": null
              }
            ],
            "type": "Campaign",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Influencer",
        "kind": "LinkedField",
        "name": "influencer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkingInstagram",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkingTwitter",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfluencerInfo",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tiktokUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ytChannel",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commonName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceNo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTiktokGoCreator",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tiktokGoStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postalCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prefectureName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cityName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "townName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buildingName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfluencerCategory",
            "kind": "LinkedField",
            "name": "influencerCategories",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mCategoryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mCategoryKeyName",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "newEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MCategory",
        "kind": "LinkedField",
        "name": "mCategories",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "keyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MPrefecture",
        "kind": "LinkedField",
        "name": "prefectures",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a456c298f7f78847350273583f0cb7a2",
    "id": null,
    "metadata": {},
    "name": "CampaignInputScreenQuery",
    "operationKind": "query",
    "text": "query CampaignInputScreenQuery(\n  $campaignId: ID!\n) {\n  campaign(id: $campaignId) {\n    __typename\n    ... on Campaign {\n      ...CampaignInputCampaign\n      id\n    }\n    ... on NotFoundError {\n      message\n    }\n  }\n  influencer {\n    ...CampaignInputInfluencer\n    id\n  }\n  ...CampaignInputCategoryMCategories\n  ...CampaignInputAddressPrefecture\n}\n\nfragment CampaignInputAddressInfluencer on Influencer {\n  postalCode\n  prefectureName\n  cityName\n  townName\n  buildingName\n  firstName\n  lastName\n}\n\nfragment CampaignInputAddressPrefecture on Query {\n  prefectures {\n    name\n    id\n  }\n}\n\nfragment CampaignInputCampaign on Campaign {\n  id\n  parentMediaType\n  ...CampaignInputSnsCampaign\n  ...requirementForApplyCampaign\n}\n\nfragment CampaignInputCategoryCategories on Influencer {\n  influencerCategories {\n    mCategoryId\n    otherContent\n    mCategoryKeyName\n    id\n  }\n}\n\nfragment CampaignInputCategoryMCategories on Query {\n  mCategories {\n    id\n    name\n    keyName\n  }\n}\n\nfragment CampaignInputEmailConfirmEmail on Influencer {\n  newEmail\n}\n\nfragment CampaignInputInfluencer on Influencer {\n  linkingInstagram\n  linkingTwitter\n  profile {\n    tiktokUrl\n    ytChannel\n    id\n  }\n  ...CampaignInputProfileInfluencer\n  ...CampaignInputSnsInfluencer\n  ...CampaignInputAddressInfluencer\n  ...CampaignInputCategoryCategories\n  ...CampaignInputEmailConfirmEmail\n  ...CampaignInputInvoiceInfluencer\n  ...requirementForApplyInfluencer\n}\n\nfragment CampaignInputInvoiceInfluencer on Influencer {\n  profile {\n    invoiceStatus\n    invoiceNo\n    id\n  }\n}\n\nfragment CampaignInputProfileInfluencer on Influencer {\n  profile {\n    commonName\n    gender\n    birthday\n    id\n  }\n}\n\nfragment CampaignInputSnsCampaign on Campaign {\n  id\n  parentMediaType\n}\n\nfragment CampaignInputSnsInfluencer on Influencer {\n  linkingInstagram\n  linkingTwitter\n  profile {\n    tiktokUrl\n    ytChannel\n    id\n  }\n}\n\nfragment requirementForApplyCampaign on Campaign {\n  parentMediaType\n  hasDelivery\n}\n\nfragment requirementForApplyInfluencer on Influencer {\n  firstName\n  lastName\n  email\n  postalCode\n  prefectureName\n  cityName\n  townName\n  linkingInstagram\n  linkingTwitter\n  phoneNumber\n  profile {\n    commonName\n    gender\n    birthday\n    tiktokUrl\n    ytChannel\n    invoiceStatus\n    isTiktokGoCreator\n    tiktokGoStatus\n    id\n  }\n  influencerCategories {\n    categoryName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b47de366db60a6825dc66d85d19df1c9";

export default node;
